<section class="bg-home">
  <div class="bg-overlay"></div>
  <div class="home-center">
    <div class="home-desc-center">
      <div class="container">
        <app-shared-search isHomePage="1"></app-shared-search>
      </div>
    </div>
  </div>
</section>
<section class="section career-oportunities">
  <app-home-career-oportunities></app-home-career-oportunities>
</section>
<app-shared-featured-jobs></app-shared-featured-jobs>
<section class="section bg-testimonials">
  <div class="bg-overlay"></div>
  <div class="container">
    <p-carousel
      #carouselTest
      [autoplayInterval]="7000"
      [circular]="true"
      [page]="3"
      [numScroll]="1"
      [numVisible]="1"
      [value]="testimonals"
      (swipeLeft)="onSwipeLeft()"
      (swipeRight)="onSwipeRight()"
    >
      <ng-template let-testimonial pTemplate="item">
        <div class="row">
          <div class="col-lg-12 text-light text-testimonial">
            {{ testimonial.testimonial }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 text-light text-author">
            {{ testimonial.author }}
          </div>
          <div class="col-lg-12 text-light text-title">
            <span>{{ testimonial.title }}{{ testimonial.experience !== '' ? ',' : '' }}</span>
            <span>{{ testimonial.experience }}</span>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</section>
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-lg-10 text-center-left">
        <h5 class="mt-2 mb-0 red">Start Your Journey with C.R. England Today!</h5>
      </div>
      <div class="col-lg-2 text-center">
        <a href="https://career.crengland.com/application">
          <button type="button" class="btn btn-white-custom">Get Started!</button>
        </a>
      </div>
    </div>
  </div>
</section>
